<form *ngIf="form" [formGroup]="form" (submit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}">

  <div class="card">
    <div class="ui-g">
      <div class="ui-g-12">
        <h2>{{ 'customerCompany.companyData' | translate }}</h2>
      </div>
    </div>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-4 form-control required">
        <label>{{ 'customerList.source_system' | translate }}</label>
        <p-dropdown #sourceSystem data-testid="sourceSystem" [options]="source_systems" formControlName="source_system" [style]="{'width':'100%'}" (onChange)="sourceSystemChange()"></p-dropdown>
      </div>
      <div class="ui-g-4 form-control required" [hidden]="!editMode && !canEditCustomerCode">
        <label>{{ 'customerList.customerCode' | translate }}</label>
        <input #customerCode data-testid="customerCode" pInputText type="text" formControlName="customer_code" (change)="customerCodeChange(customerCode)"/>
      </div>
      <div class="ui-g-4 form-control">
        <label>{{ 'customerDetail.group_number' | translate }}</label>
        <input pInputText type="text" formControlName="group_number" />
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerCompany.vatCode' | translate }}</label>
        <input pInputText type="text" formControlName="company_vat_code" />
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerCompany.companyName' | translate }}</label>
        <input pInputText type="text" formControlName="company_name" />
      </div>
      <div class="ui-g-4 form-control">
        <label>{{ 'customerCompany.professionalCategory' | translate }}</label>
        <p-dropdown [options]="profCategoryValues" [filter]="true" formControlName="prof_category_id"></p-dropdown>
      </div>
      <div class="ui-g-4 form-control">
        <label>{{ 'customerCompany.professionalSubcategory' | translate }}</label>
        <p-dropdown [options]="profSubcategoryValues" [filter]="true" formControlName="prof_subcategory_id"></p-dropdown>
      </div>

    </div>
  </div>

  <div class="card">
    <h2>{{ 'customerCompany.companyAddress' | translate }}</h2>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-4 form-control required">
        <label>{{ 'customerInfoSheet.address' | translate }}</label>
        <input pInputText type="text" formControlName="company_address" />
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerInfoSheet.number' | translate }}</label>
        <input pInputText type="text" formControlName="company_address_number" />
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerInfoSheet.zipCode' | translate }}</label>
        <input pInputText type="text" formControlName="company_zip_code" />
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerInfoSheet.country' | translate }}</label>
        <p-autoComplete
        formControlName="company_country_id"
        [suggestions]="countries"
        (completeMethod)="filterCountrySingle($event)"
        (onSelect)="onSelectCountry($event)"
        placeholder="{{ 'common.country' | translate }}"
        (onClear)="onClearCountry()"
        [minLength]="2"
        class="form-control required"
        [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}"
        field="name">
      </p-autoComplete>
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerInfoSheet.province' | translate }}</label>
        <p-dropdown [options]="provinces" [filter]="true" formControlName="company_province_id" required="true"></p-dropdown>
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerInfoSheet.city' | translate }}</label>
        <input pInputText type="text" formControlName="company_city" />
      </div>
      <div class="ui-g-6 form-control required">
        <label>{{ 'customerCompany.emailPrimary' | translate }}</label>
        <input pInputText type="text" formControlName="company_email_primary" />
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerCompany.emailSecondary' | translate }}</label>
        <input pInputText type="text" formControlName="company_email_secondary" />
      </div>
      <div class="ui-g-4 form-control required">
        <label>{{ 'customerCompany.phonePrimary' | translate }}</label>
        <input pInputText type="text" formControlName="company_phone_primary" />
      </div>
      <div class="ui-g-4 form-control">
        <label>{{ 'customerCompany.phoneMobile' | translate }}</label>
        <input pInputText type="text" formControlName="company_phone_mobile" />
      </div>
      <div class="ui-g-4 form-control">
        <label>{{ 'customerCompany.fax' | translate }}</label>
        <input pInputText type="text" formControlName="company_other_telephone" />
      </div>

    </div>
  </div>

  <div class="card">
    <h2>{{ 'customerCompany.contactPerson' | translate }}</h2>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-6 form-control required">
        <label>{{ 'customerInfoSheet.name' | translate }}</label>
        <input pInputText type="text" formControlName="name" />
      </div>
      <div class="ui-g-6 form-control required">
        <label>{{ 'customerInfoSheet.surname' | translate }}</label>
        <input pInputText type="text" formControlName="surname" />
      </div>
      <div class="ui-g-6 form-control required">
        <label>{{ 'customerInfoSheet.fiscalCode' | translate }}</label>
        <input pInputText type="text" formControlName="fiscal_code" />
      </div>
      <div class="ui-g-6 form-control required">
        <label>{{ 'customerInfoSheet.email' | translate }}</label>
        <input pInputText type="text" formControlName="email" />
      </div>
      <div class="ui-g-6 form-control required">
        <label>{{ 'customerCompany.phonePrimary' | translate }}</label>
        <input pInputText type="text" formControlName="phone_primary" />
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerCompany.phoneMobile' | translate }}</label>
        <input pInputText type="text" formControlName="phone_mobile" />
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerCompany.employmentType' | translate }}</label>
        <p-dropdown [options]="employments" [filter]="true" formControlName="employment_id"></p-dropdown>
      </div>

    </div>
  </div>

  <div class="card">
    <h2>{{ 'customerInfoSheet.authorizations' | translate }}</h2>
    <div class="ui-g ui-g-nopad form-group">
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_sendname' | translate }}</label>
        <p-inputSwitch formControlName="flag_register_name"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_generalcommunications' | translate }}</label>
        <p-inputSwitch formControlName="flag_general_communications"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_marketingresearch' | translate }}</label>
        <p-inputSwitch formControlName="flag_market_research"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control required">
        <label>{{ 'customerDetail.authorization_privacy' | translate }}</label>
        <p-inputSwitch formControlName="flag_privacy"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_profiling' | translate }}</label>
        <p-inputSwitch formControlName="flag_profiling"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_marketingactivity' | translate }}</label>
        <p-inputSwitch formControlName="flag_marketing_activities"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_purchasecommunications' | translate }}</label>
        <p-inputSwitch formControlName="flag_purchase_communications"></p-inputSwitch>
      </div>
      <div class="ui-g-6 form-control">
        <label>{{ 'customerDetail.authorization_push' | translate }}</label>
        <p-inputSwitch formControlName="flag_push_notifications"></p-inputSwitch>
      </div>
    </div>
  </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company-basic/customer-company-basic.component.html